<!-- <mat-dialog-container> -->
<mat-dialog-content class="container">
  <div *ngIf="isPurchaseOrder">
    
    <div class="notification">
      <p>{{ 'LABEL.NOTE' | translate }}</p>
      <div class="msg-list">
        <ul>
          <li class="warn">{{'PHOTO_GUID.BLACK_WHITE' | translate}}</li>
          <li class="warn">{{'PHOTO_GUID.CLEAR_FACE' | translate}}</li>
        </ul>
        <ul>
          <li class="warn">{{'PHOTO_GUID.WITHOUT_OF_FACE' | translate}}</li>
          <li class="warn">{{'PHOTO_GUID.TAKEN_WITHIN_THREE_MONTH' | translate}}</li>
        </ul>
        <ul>
          <li class="warn">{{'PHOTO_GUID.NO_HAND_GESTURES' | translate}}</li>
          <li class="warn">{{'PHOTO_GUID.FAKE_PHOTO' | translate}}</li>
        </ul>
      </div>
      <ul class="image-list">
        <li><img src="../../../assets/img/tooltip/tooltip_1.svg" alt="tootip image 1"></li>
        <li><img src="../../../assets/img/tooltip/tooltip_2.svg" alt="tootip image 2"></li>
        <li><img src="../../../assets/img/tooltip/tooltip_3.svg" alt="tootip image 3"></li>
        <li><img src="../../../assets/img/tooltip/tooltip_4.svg" alt="tootip image 4"></li>
        <li><img src="../../../assets/img/tooltip/tooltip_5.svg" alt="tootip image 5"></li>
        <li><img src="../../../assets/img/tooltip/tooltip_6.svg" alt="tootip image 6"></li>
      </ul>
    </div>

    <div class="notification-2">
      <p>{{ 'LABEL.NOTE' | translate }}</p>
      <div class="guide-1">
        <ul class="medium-msg-list">
          <li class="warn">{{'PHOTO_GUID.BLACK_WHITE' | translate}}</li>
          <li class="warn">{{'PHOTO_GUID.CLEAR_FACE' | translate}}</li>
          <li class="warn">{{'PHOTO_GUID.WITHOUT_OF_FACE' | translate}}</li>
        </ul>
        <ul class="medium-msg-list mr-0">
          <li class="warn">{{'PHOTO_GUID.TAKEN_WITHIN_THREE_MONTH' | translate}}</li>
          <li class="warn">{{'PHOTO_GUID.NO_HAND_GESTURES' | translate}}</li>
          <li class="warn">{{'PHOTO_GUID.FAKE_PHOTO' | translate}}</li>
        </ul>
      </div>
      <div class="guide-2">
        <ul class="medium-image-list">
          <li><img src="../../../assets/img/tooltip/tooltip_1.svg" alt="tootip image 1"></li>
          <li><img src="../../../assets/img/tooltip/tooltip_2.svg" alt="tootip image 2"></li>
          <li><img src="../../../assets/img/tooltip/tooltip_3.svg" alt="tootip image 3"></li>
          <li><img src="../../../assets/img/tooltip/tooltip_4.svg" alt="tootip image 4"></li>
          <li><img src="../../../assets/img/tooltip/tooltip_5.svg" alt="tootip image 5"></li>
          <li><img src="../../../assets/img/tooltip/tooltip_6.svg" alt="tootip image 6"></li>
        </ul>
      </div>
    </div>
  </div>
   
  <div class="image-wrap">
    <img crossOrigin="Anonymous" #imageCropper alt="Image">
  </div>

  <div *ngIf="cropper" class="controls">
    <div class="btn-group" role="group" aria-label="Group">
      <button mat-mini-fab mdTooltip="ធ្វើឡើងវិញ" (click)="cropper.reset()" type="button" class="btn btn-info">
        <mat-icon>restart_alt</mat-icon>
      </button>
      <button mat-mini-fab mdTooltip="ពង្រីកចូល" (click)="cropper.zoom(0.1)" type="button" class="btn btn-info">
        <mat-icon>zoom_in</mat-icon>
      </button>
      <button mat-mini-fab mdTooltip="ពង្រីកចេញ" (click)="cropper.zoom(-0.1)" type="button" class="btn btn-info">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <button mat-mini-fab mdTooltip="ត្រឡប់ទិសឈរ" (click)="cropper.scaleY(-1 * cropper.getData().scaleY)" type="button"
        class="btn btn-info">
        <mat-icon>swap_vert</mat-icon>
      </button>
      <button mat-mini-fab mdTooltip="ត្រឡប់ទិសដេក" (click)="cropper.scaleX(-1 * cropper.getData().scaleX)"
        type="button" class="btn btn-info">
        <mat-icon>swap_horiz</mat-icon>
      </button>
    </div>
    <div class="btn-group" role="group" aria-label="Rotate">
      <button mat-mini-fab mdTooltip="បង្វិលទៅឆ្វេង" color="accent" (click)="cropper.rotate(-10)" type="button"
        class="btn btn-info">
        <mat-icon>rotate_left</mat-icon>
      </button>
      <button mat-mini-fab mdTooltip="បង្វិលទៅស្ដាំ" color="accent" (click)="cropper.rotate(10)" type="button"
        class="btn btn-info">
        <mat-icon>rotate_right</mat-icon>
      </button>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="warn" mat-dialog-close>{{'LABEL.CANCEL' | translate}}</button>
  <button mat-flat-button color="accent" (click)="onSaveClick()">{{'LABEL.OK' | translate}}</button>
</mat-dialog-actions>
<!-- </mat-dialog-container> -->